import type { Story } from '../data'

export function storyRenderMode(story: Story): NonNullable<Story['renderMode']> {
  return story.renderMode ?? (story.sourceKind === 'audio' ? 'voice_conversion' : 'tts')
}

export const renarrationNotice = '동화의 대본을 부모 목소리로 새로 읽어요. 원본 음원의 배경음악·효과음·연기와 재생 길이는 그대로 유지되지 않아요.'
